/* ==========================================================================
   NEURODAZZLED — FLAGSHIP · nd-flagship.js (no dependencies)
   Header state · gentle reveal · room shelf hint · product form (real
   variants, AJAX add to bag) · mobile buy bar. The page works without it.
   Menu dialog, Noise on/off, cart count and review panel live in nd-base.js.
   ========================================================================== */
(function () {
  var html = document.documentElement;
  var S = (window.nd && window.nd.strings) || {};
  var calm = function () { return html.getAttribute('data-noise') === 'off' || html.getAttribute('data-motion') === 'reduce'; };

  /* Header: transparent over the hero, solid after it */
  function initHeader() {
    var hdr = document.querySelector('[data-f-hdr]');
    if (!hdr) return;
    var hero = document.querySelector('[data-f-hero]');
    if (hdr._fHeaderCleanup) hdr._fHeaderCleanup();
    var limit = 0, frame = 0;
    var set = function () { hdr.classList.toggle('is-solid', !hero || window.scrollY > limit); };
    var measure = function () {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(function () {
        limit = hero ? hero.getBoundingClientRect().bottom + window.scrollY - hdr.offsetHeight - 10 : 0;
        frame = 0;
        set();
      });
    };
    window.addEventListener('scroll', set, { passive: true });
    window.addEventListener('resize', measure);
    var ro = 'ResizeObserver' in window ? new ResizeObserver(measure) : null;
    if (ro) { ro.observe(hdr); if (hero) ro.observe(hero); }
    hdr._fHeaderCleanup = function () {
      window.removeEventListener('scroll', set);
      window.removeEventListener('resize', measure);
      if (ro) ro.disconnect();
      if (frame) cancelAnimationFrame(frame);
    };
    measure();
  }

  /* Reveal: only when motion is allowed and Noise is on. Never leaves content hidden. */
  var io = null;
  function initReveal(root) {
    var els = (root || document).querySelectorAll('[data-f-rv]:not(.is-in),[data-f-rvi]:not(.is-in)');
    if (calm() || !('IntersectionObserver' in window) || window.Shopify && window.Shopify.designMode) {
      html.classList.remove('f-motion');
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    html.classList.add('f-motion');
    io = io || new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });
    els.forEach(function (el) {
      io.observe(el);
    });
  }
  function revealAll() { html.classList.remove('f-motion'); document.querySelectorAll('[data-f-rv],[data-f-rvi]').forEach(function (el) { el.classList.add('is-in'); }); }
  document.addEventListener('nd:noise', function (e) { if (e.detail && e.detail.state === 'off') revealAll(); });
  document.addEventListener('nd:motion', function (e) { if (e.detail && e.detail.state === 'reduce') revealAll(); });
  setTimeout(function () { if (!io) revealAll(); }, 2500);

  /* Rooms shelf hint (mobile) */
  function initShelf(root) {
    (root || document).querySelectorAll('[data-f-shelf]').forEach(function (shelf) {
      var dots = shelf.parentNode.querySelectorAll('[data-f-shelf-hint] span');
      if (!dots.length) return;
      shelf.addEventListener('scroll', function () {
        var max = shelf.scrollWidth - shelf.clientWidth || 1;
        var i = Math.round(shelf.scrollLeft / max * (dots.length - 1));
        dots.forEach(function (d, j) { d.classList.toggle('is-on', j === i); });
      }, { passive: true });
    });
  }

  /* Product form: real variants, real cart */
  function initProduct(root) {
    (root || document).querySelectorAll('[data-f-product]').forEach(function (el) {
      if (el._f) return; el._f = true;
      var form = el.querySelector('form');
      var idInput = el.querySelector('[name="id"]');
      var variants = JSON.parse((el.querySelector('[data-f-variants]') || {}).textContent || '[]');
      var sets = [].slice.call(el.querySelectorAll('[data-f-option]'));
      var priceEl = el.querySelector('[data-f-price]');
      var btn = el.querySelector('[data-f-add]');
      var status = el.querySelector('[data-f-status]');
      var section = el.closest('section');
      var img = section.querySelector('.f-prod-img, .f-pdp__main img');
      var bar = document.querySelector('[data-f-buybar]');
      var barLab = bar && bar.querySelector('[data-f-buybar-sel]');
      var barBtn = bar && bar.querySelector('[data-f-buybar-add]');
      var labelAdd = btn ? (btn.getAttribute('data-label-add') || btn.textContent) : (S.addToBag || 'Add to bag');
      var labelOut = btn && btn.getAttribute('data-label-out');
      var sel = function () { return sets.map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; }); };
      var current = function () { if (!sets.length) { return variants.filter(function (v) { return String(v.id) === String(idInput.value); })[0] || variants[0]; } var s = sel(); return variants.filter(function (v) { return v.options.every(function (o, i) { return o === s[i]; }); })[0]; };
      function update(fromUser) {
        var s = sel();
        sets.forEach(function (fs, idx) {
          var lv = fs.querySelector('[data-f-option-value]'); if (lv) lv.textContent = s[idx] || '';
          fs.querySelectorAll('.f-pill').forEach(function (p) {
            var val = p.querySelector('input').value;
            var ok = variants.some(function (x) { return x.available && x.options[idx] === val && x.options.every(function (o, i) { return i === idx || o === s[i]; }); });
            p.classList.toggle('is-unavailable', !ok);
          });
        });
        var v = current();
        if (barLab) barLab.textContent = s.filter(Boolean).join(' · ');
        if (!v) { setBtn(false, S.unavailable || 'Unavailable'); return; }
        idInput.value = v.id;
        if (priceEl) priceEl.innerHTML = (v.price === 0 ? (S.free || 'Free') : v.price_formatted) + (v.compare_at_price > v.price ? ' <s>' + v.compare_formatted + '</s>' : '');
        setBtn(v.available, v.available ? labelAdd : (labelOut || S.soldOut || 'Sold out'));
        if (fromUser) {
          if (section.classList.contains('f-pdp')) {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', v.id);
            window.history.replaceState({}, '', url.toString());
          }
          if (img && v.image) {
            img.removeAttribute('srcset');
            img.src = v.image;
            if (v.image_alt) img.alt = v.image_alt;
            var imageLink = img.closest('[data-f-gallery-open]');
            if (imageLink) {
              var largeImage = new URL(v.image, window.location.origin);
              largeImage.searchParams.set('width', '2400');
              imageLink.href = largeImage.toString();
            }
          }
        }
      }
      function setBtn(on, label) {
        if (!btn) return;
        btn.disabled = !on; btn.textContent = label;
        if (barBtn) { barBtn.disabled = !on; barBtn.textContent = label; }
      }
      sets.forEach(function (fs) { fs.addEventListener('change', function () { update(true); }); });
      if (form) form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.textContent = S.adding || 'Adding…';
        status.textContent = '';
        fetch((window.nd && window.nd.routes && window.nd.routes.cartAdd) || '/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
          .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || S.addError); return d; }); })
          .then(function (d) { status.innerHTML = S.added || 'Added to your bag.'; document.dispatchEvent(new CustomEvent('nd:cart-updated', { detail: d })); })
          .catch(function (err) { status.innerHTML = '<span class="f-msg--err">' + ((err && err.message) || S.addError || 'Something went wrong.') + '</span>'; })
          .then(function () { btn.removeAttribute('aria-busy'); update(false); });
      });
      if (barBtn) barBtn.addEventListener('click', function () {
        if (btn.disabled) { btn.scrollIntoView({ behavior: calm() ? 'auto' : 'smooth', block: 'center' }); return; }
        form.requestSubmit ? form.requestSubmit() : form.submit();
      });
      update(false);
      /* Mobile buy bar: visible while the product section is on screen */
      var sec = el.closest('[data-f-prod-sec]');
      if (bar && sec && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            bar.classList.toggle('is-on', e.isIntersecting);
            bar.setAttribute('aria-hidden', e.isIntersecting ? 'false' : 'true');
            bar.toggleAttribute('inert', !e.isIntersecting);
            document.body.classList.toggle('f-buy-on', e.isIntersecting);
          });
        }, { threshold: 0.15 }).observe(sec);
      }
    });
  }

  function initAll(root) { initReveal(root); initShelf(root); initProduct(root); }
  initHeader();
  initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initHeader(); initAll(e.target); });
})();
/* V2 review only: compare display faces (session only, never saved to the theme) */
(function () {
  var html = document.documentElement, KEY = 'nd-review-display';
  var btns = document.querySelectorAll('[data-nd-review-display]');
  if (!btns.length) return;
  var set = function (v) {
    html.setAttribute('data-display', v);
    try { sessionStorage.setItem(KEY, v); } catch (e) {}
    btns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-nd-review-display') === v)); });
  };
  var cur = html.getAttribute('data-display') || 'bodoni';
  btns.forEach(function (b) { b.addEventListener('click', function () { set(b.getAttribute('data-nd-review-display')); }); });
  set(cur);
})();
